var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { Allow, IsArray, IsBoolean, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from "class-validator";
import { OmitType } from "@nestjs/swagger";
export var ProjectKey;
(function (ProjectKey) {
    ProjectKey["RESEARCH_OTHERORREGISTRY_DEIDENTIFIED_NONPDDE"] = "RESEARCH_OTHERORREGISTRY_DEIDENTIFIED_NONPDDE";
    ProjectKey["RESEARCH_OTHERORREGISTRY_IDENTIFIED_NONPDDE"] = "RESEARCH_OTHERORREGISTRY_IDENTIFIED_NONPDDE";
    ProjectKey["RESEARCH_INTERVENTIONAL_IDENTIFIED_NONPDDE"] = "RESEARCH_INTERVENTIONAL_IDENTIFIED_NONPDDE";
    ProjectKey["RESEARCH_OTHERORREGISTRY_IDENTIFIED_PDDE"] = "RESEARCH_OTHERORREGISTRY_IDENTIFIED_PDDE";
    ProjectKey["GENERALDATAUSE_DEIDENTIFIED_NONPDDE"] = "GENERALDATAUSE_DEIDENTIFIED_NONPDDE";
    ProjectKey["GENERALDATAUSE_IDENTIFIED_NONPDDE"] = "GENERALDATAUSE_IDENTIFIED_NONPDDE";
    ProjectKey["GENERALDATAUSE_IDENTIFIED_PDDE"] = "GENERALDATAUSE_IDENTIFIED_PDDE";
})(ProjectKey || (ProjectKey = {}));
export const activeProjectKeys = {
    RESEARCH_OTHERORREGISTRY_DEIDENTIFIED_NONPDDE: false,
    RESEARCH_OTHERORREGISTRY_IDENTIFIED_NONPDDE: false,
    RESEARCH_INTERVENTIONAL_IDENTIFIED_NONPDDE: false,
    RESEARCH_OTHERORREGISTRY_IDENTIFIED_PDDE: false,
    GENERALDATAUSE_DEIDENTIFIED_NONPDDE: false,
    GENERALDATAUSE_IDENTIFIED_NONPDDE: false,
    GENERALDATAUSE_IDENTIFIED_PDDE: true,
};
export const projectPreviewOptionsEnabled = {
    GENERALDATAUSE_IDENTIFIED_PDDE: {
        consentFlow: false,
        participantType: false,
    },
};
export var ProjectPageName;
(function (ProjectPageName) {
    ProjectPageName["PROJECT_DETAILS"] = "PROJECT_DETAILS";
    ProjectPageName["INFORMATION_FOR_PATIENTS"] = "INFORMATION_FOR_PATIENTS";
    ProjectPageName["PROJECT_SETTINGS"] = "PROJECT_SETTINGS";
    ProjectPageName["PATIENT_EXPERIENCE"] = "PATIENT_EXPERIENCE";
})(ProjectPageName || (ProjectPageName = {}));
export var ProjectFieldType;
(function (ProjectFieldType) {
    ProjectFieldType["SUBSECTION"] = "SUBSECTION";
    ProjectFieldType["SUBSECTION_END"] = "SUBSECTION_END";
    ProjectFieldType["TEXTFIELD"] = "TEXTFIELD";
    ProjectFieldType["RADIO"] = "RADIO";
    ProjectFieldType["NUMBER"] = "NUMBER";
    ProjectFieldType["CHECKBOX"] = "CHECKBOX";
    ProjectFieldType["DATE"] = "DATE";
    ProjectFieldType["SWITCH"] = "SWITCH";
})(ProjectFieldType || (ProjectFieldType = {}));
export const projectPageTitle = {
    PROJECT_DETAILS: "Project details",
    INFORMATION_FOR_PATIENTS: "Information for patients",
    PROJECT_SETTINGS: "Project settings",
    PATIENT_EXPERIENCE: "Patient experience",
};
export const projectPageDescriptions = {
    PROJECT_DETAILS: "Provide key information to help your team understand and reference this project. This information will only be shown internally to members of your organization.",
    INFORMATION_FOR_PATIENTS: "TODO: add correct subtitle.",
    PROJECT_SETTINGS: "Provide key information to help your team understand and reference this project. This information will only be shown internally to members of your organization.",
    PATIENT_EXPERIENCE: "Configure the information patients will see as part of their mobile experience during the consent process. This content will be visible to patients.",
};
export var ProjectSectionName;
(function (ProjectSectionName) {
    ProjectSectionName["OVERVIEW"] = "OVERVIEW";
    ProjectSectionName["KEY_RESOURCES"] = "KEY_RESOURCES";
    ProjectSectionName["STUDY_SETTINGS"] = "STUDY_SETTINGS";
    ProjectSectionName["PATIENT_OUTREACH_SETTINGS"] = "PATIENT_OUTREACH_SETTINGS";
    ProjectSectionName["HEALTH_RECORD_UPDATE_SETTINGS"] = "HEALTH_RECORD_UPDATE_SETTINGS";
    ProjectSectionName["LOGIN"] = "LOGIN";
    ProjectSectionName["WELCOME"] = "WELCOME";
    ProjectSectionName["HEALTH_RECORD_EXPLANATION"] = "HEALTH_RECORD_EXPLANATION";
    ProjectSectionName["RECIPIENTS_AND_THIRD_PARTIES"] = "RECIPIENTS_AND_THIRD_PARTIES";
    ProjectSectionName["PURPOSE_OF_DATA_ACCESS_AND_USE"] = "PURPOSE_OF_DATA_ACCESS_AND_USE";
    ProjectSectionName["STATESPECIFIC_REQUIREMENTS"] = "STATESPECIFIC_REQUIREMENTS";
    ProjectSectionName["STUDY_INFORMATION"] = "STUDY_INFORMATION";
    ProjectSectionName["INTRODUCTION"] = "INTRODUCTION";
    ProjectSectionName["PURPOSE_OF_RESEARCH"] = "PURPOSE_OF_RESEARCH";
    ProjectSectionName["STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS"] = "STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS";
    ProjectSectionName["PROCEDURES_AND_INTERVENTIONS"] = "PROCEDURES_AND_INTERVENTIONS";
    ProjectSectionName["PARTICIPATION_ACTIVITIES_AND_PROCEDURES"] = "PARTICIPATION_ACTIVITIES_AND_PROCEDURES";
    ProjectSectionName["TIMELINE_FOR_VISITS_AND_INTERVENTIONS"] = "TIMELINE_FOR_VISITS_AND_INTERVENTIONS";
    ProjectSectionName["STUDY_BENEFITS"] = "STUDY_BENEFITS";
    ProjectSectionName["STUDY_RISKS"] = "STUDY_RISKS";
    ProjectSectionName["PATIENT_COMPENSATION"] = "PATIENT_COMPENSATION";
    ProjectSectionName["COST_OF_PARTICIPATION"] = "COST_OF_PARTICIPATION";
    ProjectSectionName["VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES"] = "VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES";
    ProjectSectionName["INJURY_PROTOCOL"] = "INJURY_PROTOCOL";
    ProjectSectionName["WITHDRAWAL_IMPLICATIONS"] = "WITHDRAWAL_IMPLICATIONS";
    ProjectSectionName["PARTICIPATION_TERMINATION"] = "PARTICIPATION_TERMINATION";
    ProjectSectionName["HEALTH_RECORD_SOURCE_AND_SCOPE"] = "HEALTH_RECORD_SOURCE_AND_SCOPE";
    ProjectSectionName["VOLUNTARY_HEALTH_RECORD_USE"] = "VOLUNTARY_HEALTH_RECORD_USE";
    ProjectSectionName["CONSENT_EXPIRATION_AND_REVOCATION"] = "CONSENT_EXPIRATION_AND_REVOCATION";
    ProjectSectionName["FUTURE_USE_OF_HEALTH_RECORDS"] = "FUTURE_USE_OF_HEALTH_RECORDS";
    ProjectSectionName["PATIENT_HEALTH_RECORD_RIGHTS"] = "PATIENT_HEALTH_RECORD_RIGHTS";
    ProjectSectionName["HEALTH_RECORD_UPDATES"] = "HEALTH_RECORD_UPDATES";
    ProjectSectionName["CONFIDENTALITY_MEASURES"] = "CONFIDENTALITY_MEASURES";
    ProjectSectionName["RESEARCH_RESULTS"] = "RESEARCH_RESULTS";
    ProjectSectionName["WHO_TO_CONTACT"] = "WHO_TO_CONTACT";
    ProjectSectionName["ADDITIONAL_INFORMATION"] = "ADDITIONAL_INFORMATION";
    ProjectSectionName["ADDITIONAL_INFORMATION_1"] = "ADDITIONAL_INFORMATION_1";
    ProjectSectionName["ADDITIONAL_INFORMATION_2"] = "ADDITIONAL_INFORMATION_2";
    ProjectSectionName["ADDITIONAL_INFORMATION_3"] = "ADDITIONAL_INFORMATION_3";
    ProjectSectionName["ADDITIONAL_INFORMATION_4"] = "ADDITIONAL_INFORMATION_4";
    ProjectSectionName["ADDITIONAL_INFORMATION_5"] = "ADDITIONAL_INFORMATION_5";
    ProjectSectionName["ADDITIONAL_INFORMATION_6"] = "ADDITIONAL_INFORMATION_6";
    ProjectSectionName["ADDITIONAL_INFORMATION_7"] = "ADDITIONAL_INFORMATION_7";
    ProjectSectionName["ADDITIONAL_INFORMATION_8"] = "ADDITIONAL_INFORMATION_8";
    ProjectSectionName["ADDITIONAL_INFORMATION_9"] = "ADDITIONAL_INFORMATION_9";
    ProjectSectionName["ADDITIONAL_INFORMATION_10"] = "ADDITIONAL_INFORMATION_10";
    ProjectSectionName["PATIENT_CONSENT"] = "PATIENT_CONSENT";
    ProjectSectionName["PATIENT_SIGNATURE"] = "PATIENT_SIGNATURE";
    ProjectSectionName["PARENTGUARDIAN_SIGNATURE"] = "PARENTGUARDIAN_SIGNATURE";
    ProjectSectionName["WITNESS_SIGNATURE"] = "WITNESS_SIGNATURE";
    ProjectSectionName["CONSENT_FACILITATOR_SIGNATURE"] = "CONSENT_FACILITATOR_SIGNATURE";
    ProjectSectionName["CONSENT_CONFIRMATION"] = "CONSENT_CONFIRMATION";
    ProjectSectionName["DECLINE_CONSENT_CONFIRMATION"] = "DECLINE_CONSENT_CONFIRMATION";
    ProjectSectionName["NEEDS_FOLLOWUP_CONFIRMATION"] = "NEEDS_FOLLOWUP_CONFIRMATION";
    ProjectSectionName["ABOUT_THE_PROJECT"] = "ABOUT_THE_PROJECT";
    ProjectSectionName["PATIENT_RECORD_RETRIEVAL_RECENCY"] = "PATIENT_RECORD_RETRIEVAL_RECENCY";
    ProjectSectionName["REQUEST_DETAILS"] = "REQUEST_DETAILS";
    ProjectSectionName["FREQUENTLY_ASKED_QUESTIONS"] = "FREQUENTLY_ASKED_QUESTIONS";
    ProjectSectionName["CONFIRM_ACCESS"] = "CONFIRM_ACCESS";
    ProjectSectionName["CONFIRMATION_OF_RECORDS_SHARED"] = "CONFIRMATION_OF_RECORDS_SHARED";
    ProjectSectionName["CONFIRMATION_OF_DECLINE"] = "CONFIRMATION_OF_DECLINE";
})(ProjectSectionName || (ProjectSectionName = {}));
export const projectSectionTitle = {
    OVERVIEW: "Overview",
    KEY_RESOURCES: "Key resources",
    STUDY_SETTINGS: "Study settings",
    PATIENT_OUTREACH_SETTINGS: "Patient outreach settings",
    HEALTH_RECORD_UPDATE_SETTINGS: "Health record update settings",
    LOGIN: "Login",
    WELCOME: "Welcome",
    HEALTH_RECORD_EXPLANATION: "Health record explanation",
    RECIPIENTS_AND_THIRD_PARTIES: "Recipients and third parties",
    PURPOSE_OF_DATA_ACCESS_AND_USE: "Purpose of data access and use",
    STATESPECIFIC_REQUIREMENTS: "State-specific requirements",
    STUDY_INFORMATION: "Study information",
    INTRODUCTION: "Introduction",
    PURPOSE_OF_RESEARCH: "Purpose of research",
    STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS: "Study length and number of participants",
    PROCEDURES_AND_INTERVENTIONS: "Procedures and interventions",
    PARTICIPATION_ACTIVITIES_AND_PROCEDURES: "Participation activities and procedures",
    TIMELINE_FOR_VISITS_AND_INTERVENTIONS: "Timeline for visits and interventions",
    STUDY_BENEFITS: "Study benefits",
    STUDY_RISKS: "Study risks",
    PATIENT_COMPENSATION: "Patient compensation",
    COST_OF_PARTICIPATION: "Cost of participation",
    VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES: "Voluntary participation and alternatives",
    INJURY_PROTOCOL: "Injury protocol",
    WITHDRAWAL_IMPLICATIONS: "Withdrawal implications",
    PARTICIPATION_TERMINATION: "Participation termination",
    HEALTH_RECORD_SOURCE_AND_SCOPE: "Health record source and scope",
    VOLUNTARY_HEALTH_RECORD_USE: "Voluntary health record use",
    CONSENT_EXPIRATION_AND_REVOCATION: "Consent expiration and revocation",
    FUTURE_USE_OF_HEALTH_RECORDS: "Future use of health records",
    PATIENT_HEALTH_RECORD_RIGHTS: "Patient health record rights",
    HEALTH_RECORD_UPDATES: "Health record updates",
    CONFIDENTALITY_MEASURES: "Confidentiality measures",
    RESEARCH_RESULTS: "Research results",
    WHO_TO_CONTACT: "Who to contact",
    ADDITIONAL_INFORMATION: "Additional information",
    ADDITIONAL_INFORMATION_1: "Additional information #1",
    ADDITIONAL_INFORMATION_2: "Additional information #2",
    ADDITIONAL_INFORMATION_3: "Additional information #3",
    ADDITIONAL_INFORMATION_4: "Additional information #4",
    ADDITIONAL_INFORMATION_5: "Additional information #5",
    ADDITIONAL_INFORMATION_6: "Additional information #6",
    ADDITIONAL_INFORMATION_7: "Additional information #7",
    ADDITIONAL_INFORMATION_8: "Additional information #8",
    ADDITIONAL_INFORMATION_9: "Additional information #9",
    ADDITIONAL_INFORMATION_10: "Additional information #10",
    PATIENT_CONSENT: "Patient consent",
    PATIENT_SIGNATURE: "Patient signature",
    PARENTGUARDIAN_SIGNATURE: "Parent/guardian signature",
    WITNESS_SIGNATURE: "Witness signature",
    CONSENT_FACILITATOR_SIGNATURE: "Consent facilitator signature",
    CONSENT_CONFIRMATION: "Consent confirmation",
    DECLINE_CONSENT_CONFIRMATION: "Decline consent confirmation",
    NEEDS_FOLLOWUP_CONFIRMATION: "Needs follow-up confirmation",
    ABOUT_THE_PROJECT: "About the project",
    REQUEST_DETAILS: "Request details",
    FREQUENTLY_ASKED_QUESTIONS: "Frequently asked questions",
    CONFIRM_ACCESS: "Confirm access",
    CONFIRMATION_OF_RECORDS_SHARED: "Confirmation of records shared",
    CONFIRMATION_OF_DECLINE: "Confirmation of decline",
    PATIENT_RECORD_RETRIEVAL_RECENCY: "Patient record retrieval recency",
};
export const projectSectionDescription = {
    OVERVIEW: "Add the core details about your project, including its title, description, and any project identifiers.",
    KEY_RESOURCES: "",
    STUDY_SETTINGS: "",
    PATIENT_OUTREACH_SETTINGS: "Defines how your teams will reach out to patients about this initiative. Patients can be contacted via email or SMS.",
    HEALTH_RECORD_UPDATE_SETTINGS: "Determines how often patients will be asked to share an updated copy of their records. This will be reflected in the patient experience.",
    LOGIN: "",
    WELCOME: "Introduces the patient to the request.",
    HEALTH_RECORD_EXPLANATION: "Educates patients on what health records are.",
    RECIPIENTS_AND_THIRD_PARTIES: "Outlines how health records will be used and who they’ll be shared with.",
    PURPOSE_OF_DATA_ACCESS_AND_USE: "Provides an introduction to the request and why data is being requested.",
    STATESPECIFIC_REQUIREMENTS: "",
    STUDY_INFORMATION: "",
    INTRODUCTION: "",
    PURPOSE_OF_RESEARCH: "",
    STUDY_LENGTH_AND_NUMBER_OF_PARTICIPANTS: "",
    PROCEDURES_AND_INTERVENTIONS: "",
    PARTICIPATION_ACTIVITIES_AND_PROCEDURES: "",
    TIMELINE_FOR_VISITS_AND_INTERVENTIONS: "",
    STUDY_BENEFITS: "",
    STUDY_RISKS: "",
    PATIENT_COMPENSATION: "",
    COST_OF_PARTICIPATION: "",
    VOLUNTARY_PARTICIPATION_AND_ALTERNATIVES: "",
    CONSENT_EXPIRATION_AND_REVOCATION: "Explains when the data can no longer be accessed, and how patients can revoke consent.",
    INJURY_PROTOCOL: "",
    WITHDRAWAL_IMPLICATIONS: "",
    PARTICIPATION_TERMINATION: "",
    HEALTH_RECORD_SOURCE_AND_SCOPE: "Describes who is disclosing the health records and helps patients understand the sensitivity and scope of the information involved.",
    VOLUNTARY_HEALTH_RECORD_USE: "Reminds the patient that this is a voluntary decision.",
    FUTURE_USE_OF_HEALTH_RECORDS: "",
    PATIENT_HEALTH_RECORD_RIGHTS: "",
    HEALTH_RECORD_UPDATES: "Informs the patient if their health records may need periodic updates to maintain accuracy, and may require them to take an action.",
    CONFIDENTALITY_MEASURES: "",
    RESEARCH_RESULTS: "",
    WHO_TO_CONTACT: "Provides patients with contact information of who they can to reach out to with questions.",
    ADDITIONAL_INFORMATION: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_1: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_2: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_3: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_4: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_5: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_6: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_7: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_8: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_9: "Additional details for the patient.",
    ADDITIONAL_INFORMATION_10: "Additional details for the patient.",
    PATIENT_CONSENT: "",
    PATIENT_SIGNATURE: "Obtains the patient's signature to confirm their understanding and consent to grant access to their health records.",
    PARENTGUARDIAN_SIGNATURE: "",
    WITNESS_SIGNATURE: "",
    CONSENT_FACILITATOR_SIGNATURE: "",
    CONSENT_CONFIRMATION: "Thanks the patient for their time reviewing the request. This is only shown to patients who say yes.",
    DECLINE_CONSENT_CONFIRMATION: "Thanks the patient for their time reviewing the request. This is only shown to patients who say no.",
    NEEDS_FOLLOWUP_CONFIRMATION: "",
    ABOUT_THE_PROJECT: "",
    PATIENT_RECORD_RETRIEVAL_RECENCY: "Determines how recently patient records must be retrieved through HealthEx for this project. Records retrieved prior to the specified timeframe will require patients to re-retrieve their records.",
    REQUEST_DETAILS: "Provides further information about the request.",
    FREQUENTLY_ASKED_QUESTIONS: "Answers common questions that patients might have before they respond to the request.",
    CONFIRM_ACCESS: "Obtains the patient’s consent to access and share records. Consent is renewed only if the prior one has expired.",
    CONFIRMATION_OF_RECORDS_SHARED: "Shown to patients who agree to share their records for this request.",
    CONFIRMATION_OF_DECLINE: "Shown to patients who decline to share their records for this request.",
};
export const projectSectionCustomGap = (sectionName) => {
    switch (sectionName) {
        case ProjectSectionName.PATIENT_RECORD_RETRIEVAL_RECENCY:
            return 16;
        default:
            return null;
    }
};
export var ProjectFieldRequirement;
(function (ProjectFieldRequirement) {
    ProjectFieldRequirement["OPTIONAL"] = "OPTIONAL";
    ProjectFieldRequirement["REQUIRED"] = "REQUIRED";
    ProjectFieldRequirement["FORCE_SECTION_REQUIRED"] = "FORCE_SECTION_REQUIRED";
    ProjectFieldRequirement["VIEW_ONLY"] = "VIEW_ONLY";
    ProjectFieldRequirement["SECTION_INCLUDE"] = "SECTION_INCLUDE";
})(ProjectFieldRequirement || (ProjectFieldRequirement = {}));
export class ProjectRawDataEntry {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(ProjectPageName),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "pageName", void 0);
__decorate([
    IsEnum(ProjectSectionName),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "sectionName", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "includeFieldName", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "fieldName", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "specialFieldName", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "viewOnlyFieldName", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "viewOnlySpecialCaseFieldName", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "fieldSectionAddImageName", void 0);
__decorate([
    Type(() => String),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ProjectRawDataEntry.prototype, "fieldIncludeFields", void 0);
__decorate([
    Type(() => String),
    IsArray(),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ProjectRawDataEntry.prototype, "translatableFieldNames", void 0);
__decorate([
    Type(() => String),
    IsArray(),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ProjectRawDataEntry.prototype, "informedConsentFieldNames", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    __metadata("design:type", Object)
], ProjectRawDataEntry.prototype, "fieldRequirements", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "label", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "translationLabel", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "useTranslationLabelFieldName", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectRawDataEntry.prototype, "showLabelTooltip", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "placeholder", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "placeholderKey", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "additionalHelperText", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectRawDataEntry.prototype, "multiline", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ProjectRawDataEntry.prototype, "minRows", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "switchLabel", void 0);
__decorate([
    IsEnum(ProjectFieldType),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "fieldType", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ProjectRawDataEntry.prototype, "characterLimit", void 0);
__decorate([
    Type(() => ProjectRawDataEntryOption),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ProjectRawDataEntry.prototype, "options", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectRawDataEntry.prototype, "isLastAdditionalSection", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "subsectionHeaderText", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "subsectionFooterText", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectRawDataEntry.prototype, "showSubsectionDivider", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectRawDataEntry.prototype, "showSubsectionDividerKey", void 0);
export class ProjectRawDataEntryOption {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProjectRawDataEntryOption.prototype, "label", void 0);
__decorate([
    Allow(),
    __metadata("design:type", Object)
], ProjectRawDataEntryOption.prototype, "value", void 0);
export class ProjectDataEntry extends OmitType(ProjectRawDataEntry, ["fieldRequirements"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsObject(),
    ValidateNested(),
    __metadata("design:type", String)
], ProjectDataEntry.prototype, "fieldRequirement", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataEntry.prototype, "objId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataEntry.prototype, "fieldValue", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataEntry.prototype, "includeValue", void 0);
export class ProjectDataField extends OmitType(ProjectDataEntry, ["pageName", "sectionName"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectDataField.prototype, "isFilledIn", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectDataField.prototype, "isRequiredCompleted", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectDataField.prototype, "isRequiredError", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ProjectDataField.prototype, "isFieldIncluded", void 0);
export var ProjectSectionType;
(function (ProjectSectionType) {
    ProjectSectionType["STANDARD"] = "STANDARD";
    ProjectSectionType["OPTIONAL"] = "OPTIONAL";
    ProjectSectionType["REQUIRED"] = "REQUIRED";
    ProjectSectionType["VIEW_ONLY"] = "VIEW_ONLY";
})(ProjectSectionType || (ProjectSectionType = {}));
export const projectHumanSectionType = {
    STANDARD: "",
    OPTIONAL: "Optional",
    REQUIRED: "Required",
    VIEW_ONLY: "View-only",
};
export class ProjectDataSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(ProjectPageName),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "pageName", void 0);
__decorate([
    IsEnum(ProjectSectionName),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "sectionName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "title", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "description", void 0);
__decorate([
    IsEnum(ProjectSectionType),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "sectionType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "displayType", void 0);
__decorate([
    Type(() => String),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ProjectDataSection.prototype, "sectionIncludeField", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataSection.prototype, "sectionIncludeFieldValue", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProjectDataSection.prototype, "isReviewed", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProjectDataSection.prototype, "areRequiredFieldsCompleted", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProjectDataSection.prototype, "isCompleted", void 0);
__decorate([
    Type(() => ProjectDataField),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ProjectDataSection.prototype, "fields", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataSection.prototype, "objId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataSection.prototype, "isLastAdditionalSection", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], ProjectDataSection.prototype, "sectionGap", void 0);
export class ProjectDataPage {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(ProjectPageName),
    __metadata("design:type", String)
], ProjectDataPage.prototype, "pageName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProjectDataPage.prototype, "title", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ProjectDataPage.prototype, "description", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPage.prototype, "sectionsCompleted", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPage.prototype, "progress", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProjectDataPage.prototype, "isCompleted", void 0);
__decorate([
    Type(() => ProjectDataSection),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ProjectDataPage.prototype, "sections", void 0);
export class ProjectDataPages {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPages.prototype, "sectionsCompleted", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPages.prototype, "sectionsTotal", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPages.prototype, "pagesCompleted", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPages.prototype, "progress", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProjectDataPages.prototype, "isCompleted", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProjectDataPages.prototype, "isAtLeastOneInformedConsentFieldFilled", void 0);
__decorate([
    Type(() => String),
    IsArray(),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ProjectDataPages.prototype, "requiredInformedConsentFieldNames", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], ProjectDataPages.prototype, "emptyRequiredInformedConsentFields", void 0);
__decorate([
    Type(() => String),
    IsArray(),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ProjectDataPages.prototype, "optionalInformedConsentFieldNames", void 0);
__decorate([
    Type(() => ProjectDataPage),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], ProjectDataPages.prototype, "pages", void 0);
export var ProjectStaticPageName;
(function (ProjectStaticPageName) {
    ProjectStaticPageName["TRANSLATIONS"] = "TRANSLATIONS";
    ProjectStaticPageName["PREVIEW"] = "PREVIEW";
})(ProjectStaticPageName || (ProjectStaticPageName = {}));
